import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { Terminal, PaginatedTerminalResponse } from 'interfaces/terminal'

interface TerminalFilters {
  page?: number // We'll convert this to offset internally
  limit?: number
  status?: string
  search?: string
  locationCode?: string
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
}

const fetchTerminals = async (
  filters: TerminalFilters = {}
): Promise<PaginatedTerminalResponse> => {
  const params = new URLSearchParams()

  // Convert page to offset (PNS uses offset-based pagination)
  if (filters.page && filters.limit) {
    const offset = (filters.page - 1) * filters.limit
    params.append('offset', offset.toString())
  }
  if (filters.limit) params.append('limit', filters.limit.toString())
  if (filters.status) params.append('status', filters.status)
  if (filters.search) params.append('search', filters.search)
  if (filters.locationCode) params.append('locationCode', filters.locationCode)
  if (filters.sortBy) params.append('sortBy', filters.sortBy)
  if (filters.sortOrder) params.append('sortOrder', filters.sortOrder)

  let response = await fetch(
    `${BASE_API_URL}/api/v4/phone_number_service/terminals?${params.toString()}`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )

  response = handleErrors(response)
  return response.json()
}

const useTerminals = (filters: TerminalFilters = {}) => {
  return useQuery(['terminals', filters], () => fetchTerminals(filters), {
    staleTime: 30000, // 30 seconds
    retry: 2,
  })
}

export default useTerminals
